export default function premiumGuard(Authentication, AccountService, sdk) {
  'ngInject';

  return {
    scope: true,
    transclude: true,
    template: `
      <div ng-class="{'premium-guard': noAccess(), clickable: $root.authentication.user.isManager}"
           ng-click="premiumGuardClicked($event)"
           uib-tooltip="{{ getPremiumGuardTooltip() }}"
           ng-transclude>
      </div>
    `,
    compile($compileElement, $compileAttrs) {
      const SUBSCRIPTION_NAMES = sdk('constants').SUBSCRIPTION_NAMES;

      if ($compileAttrs.tooltipPlacement) {
        $compileElement.children().eq(0).attr('tooltip-placement', $compileAttrs.tooltipPlacement);
      }

      if ('tooltipAppendToBody' in $compileAttrs) {
        $compileElement.children().eq(0).attr('tooltip-append-to-body', true);
      }

      return {
        post($scope, $element, $attrs) {
          $scope.noAccess = () => {
            if ('premiumGuardActive' in $attrs && !$scope.$eval($attrs.premiumGuardActive)) {
              return false;
            }

            if ($attrs.condition) {
              return !$scope.$eval($attrs.condition);
            }

            return (
              Authentication.user &&
              ($attrs.premiumGuard
                ? !Authentication.isOrgFeatureEnabled($attrs.premiumGuard)
                : !Authentication.user.org.isPremium)
            );
          };

          $scope.getPremiumGuardTooltip = () => {
            if ($attrs.includeTooltip === 'false') {
              return null
            }
            if ($scope.noAccess()) {
              const requiredPlan = _getRequiredPlan();
              const tooltip = $attrs.tooltipText || `This feature is available in ${requiredPlan}`;

              return $attrs.premiumGuardModal ? `${tooltip}. Click to learn more.` : tooltip;
            }
          };

          $scope.premiumGuardClicked = (e) => {
            if ($scope.noAccess() && !('guardNoClick' in $attrs) && Authentication.user.isManager) {
              e.preventDefault();

              if ('premiumGuardStopPropagation' in $attrs) {
                e.stopPropagation();
              }

              if ('premiumGuardCallback' in $attrs) {
                $scope.$eval($attrs.premiumGuardCallback);
              }

              AccountService.openPremiumGuardModal(
                $attrs.premiumGuardModal,
                undefined,
                $attrs.premiumGuard
              );
            }
          };

          function _getRequiredPlan() {
            if (Authentication.user.org.isToastSignup) {
              return 'Scheduling Pro';
            }

            if ($attrs.premiumGuard && !Authentication.isOldPremium) {
              return SUBSCRIPTION_NAMES[
                Authentication.user.orgSettings.premiumFeatures[$attrs.premiumGuard]
              ];
            }

            return 'Premium';
          }
        },
      };
    },
  };
}
